import {Component} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {AuthenticationRestApiService} from '../services/http/authentication-rest-api.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslocoService} from '@jsverse/transloco';
import {RoutesEnum} from '../../../core/services/navigation/routes.enum';
import {LanguageService} from '../../../core/services/language/language.service';
import {NavigationService} from '../../../core/services/navigation/navigation.service';

@Component({
  selector: 'xp-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../authentication.common.scss', './forgot-password.component.scss'],
})
export class ForgotPasswordComponent {

  public readonly formGroup = this._formBuilder.group({
    email: ['', [Validators.required.bind(Validators), Validators.email.bind(Validators)]],
  });

  public isProcessing: boolean = false;
  public error: string = '';

  constructor(
    private readonly _authenticationRestApiService: AuthenticationRestApiService,
    private readonly _formBuilder: FormBuilder,
    private readonly _snackBar: MatSnackBar,
    private readonly _translocoService: TranslocoService,
    private readonly _languageService: LanguageService,
    private readonly _navigationService: NavigationService,
  ) {
  }

  public get loginRoute(): Array<string> {
    return ['/', RoutesEnum.AUTHENTICATION];
  }

  public askResetPasswordLink(): void {
    if (this.formGroup.invalid) {
      return;
    }
    this.isProcessing = true;
    this._authenticationRestApiService.requestPasswordResetLink({
      email: this.formGroup.controls.email.value ?? '',
      lang: this._languageService.activeLanguage,
    })
      .subscribe({
        next: async () => {
          this._snackBar.open(
            this._translocoService.translate(
              'AUTHENTICATION.FORGOT_PASSWORD.SUCCESS',
              {email: this.formGroup.controls.email.value ?? ''},
            ),
            '',
            {duration: 7000},
          );
          await this._navigationService.navigateTo(RoutesEnum.AUTHENTICATION);
        },
        error: () => {
          this.isProcessing = false;
          this.error = this._translocoService.translate('SHARED.ERRORS.UNKNOWN');
        },
      });
  }
}
